// Module
var code = "<div class=\"step-text-style\"> <slot></slot> </div> ";
// Exports
export default code;